module.exports = __webpack_public_path__ + "static/media/chevron_down.f7aa6ad0.svg";